import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import LoginForm from '../components/auth/LoginForm';
import GuestButton from '../components/auth/GuestButton';

const LoginPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, display: 'flex', justifyContent: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Welcome to Learn2Skill
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Sign in to your account or continue as guest to start learning
          </Typography>
          <LoginForm />
          <GuestButton />
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage;

